import { useMutation } from "@tanstack/react-query"
import type {
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query"

import client from "~/backend/axiosClient"

import type { HelloControllerGetHelloMutationResponse } from "../types/HelloControllerGetHello"

type HelloControllerGetHelloClient = typeof client<
  HelloControllerGetHelloMutationResponse,
  Error,
  never
>
type HelloControllerGetHello = {
  data: HelloControllerGetHelloMutationResponse
  error: Error
  request: never
  pathParams: never
  queryParams: never
  headerParams: never
  response: Awaited<ReturnType<HelloControllerGetHelloClient>>
  client: {
    parameters: Partial<Parameters<HelloControllerGetHelloClient>[0]>
    return: Awaited<ReturnType<HelloControllerGetHelloClient>>
  }
}
/**
 * @link /
 */
export function useHelloControllerGetHello(
  options: {
    mutation?: UseMutationOptions<
      HelloControllerGetHello["response"],
      HelloControllerGetHello["error"],
      HelloControllerGetHello["request"]
    >
    client?: HelloControllerGetHello["client"]["parameters"]
  } = {}
): UseMutationResult<
  HelloControllerGetHello["response"],
  HelloControllerGetHello["error"],
  HelloControllerGetHello["request"]
> {
  const { mutation: mutationOptions, client: clientOptions = {} } =
    options ?? {}
  return useMutation<
    HelloControllerGetHello["response"],
    HelloControllerGetHello["error"],
    never
  >({
    mutationFn: async () => {
      const res = await client<
        HelloControllerGetHello["data"],
        HelloControllerGetHello["error"],
        HelloControllerGetHello["request"]
      >({
        method: "post",
        url: `/`,
        ...clientOptions,
      })
      return res
    },
    ...mutationOptions,
  })
}
